<script setup>
import ServiceTable from '@frontJs/components/tables/projectManagement/customers/ServiceTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Prestations - Clients - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Clients - Prestations </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(ServiceTable),
            },
            eCommerce: {
                title: 'E-commerce',
                content: h(ServiceTable, { type: 'e-commerce' }),
            },
            showcase: {
                title: 'Vitrine',
                content: h(ServiceTable, { type: 'showcase' }),
            },
            marketplace: {
                title: 'Marketplace',
                content: h(ServiceTable, { type: 'marketplace' }),
            },
            shop: {
                title: 'Boutique',
                content: h(ServiceTable, { type: 'shop' }),
            },
            customMade: {
                title: 'Sur-mesure',
                content: h(ServiceTable, { type: 'custom-made' }),
            },
            other: {
                title: 'Autre',
                content: h(ServiceTable, { type: 'other' }),
            },
        }"
    />
</template>
